import React, { Component } from "react";
import "./otp-input.styles.css";

export class CustomOtpInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            otp: "        ",
            refs: [
                React.createRef(),
                React.createRef(),
                React.createRef(),
                React.createRef(),
                React.createRef(),
                React.createRef(),
                React.createRef(),
                React.createRef(),
            ],
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.otp !== this.state.otp) {
            this.props.onChange(this.state.otp.trim());
        }
    }

    handleKeyPress = (index, e) => {
        if (e.key === "Backspace" || e.keyCode === "229") {
            if (this.state.otp[index] === " ") {
                this.setState({
                    otp: `${this.state.otp.substring(0, index - 1)}${this.state.otp.substring(index + 1)} `.padEnd(
                        8,
                        " "
                    ),
                });
            } else {
                this.setState({
                    otp: `${this.state.otp.substring(0, index)} ${this.state.otp.substring(index + 1)} `.padEnd(8, " "),
                });
            }
            this.state.refs[Math.max(0, index - 1)].current.focus();
        } else if (e.key === "ArrowRight") {
            this.state.refs[Math.min(7, index + 1)].current.focus();
        } else if (e.key === "ArrowLeft") {
            this.state.refs[Math.max(0, index - 1)].current.focus();
        } else if (["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "0"].includes(e.key)) {
            if (this.state.otp[index] === " ") {
                this.setState({
                    otp: `${this.state.otp.substring(0, index)}${e.key}${this.state.otp.substring(
                        index + 1
                    )}`.substring(0, 8),
                });
            } else {
                this.setState({
                    otp: `${this.state.otp.substring(0, index + 1)}${e.key}${this.state.otp.substring(
                        index + 2
                    )}`.substring(0, 8),
                });
            }
            this.state.refs[Math.min(7, index + 1)].current.focus();
        }
    };

    handleFocus = (index) => {
        if (this.state.otp[index] !== " ") {
            this.state.refs[index].current.setSelectionRange(0, 1);
        }
    };

    handlePaste = (index, e) => {
        var pastedData = e.clipboardData.getData("Text").trim();
        if (new RegExp("^[0-9]*$").test(pastedData)) {
            this.setState({
                otp: `${this.state.otp.substring(0, index)}${pastedData}${this.state.otp.substring(
                    index + pastedData.length
                )}`.substring(0, 8),
            });
        }
    };

    render() {
        return (
            <div className="optWrapper">
                {this.state.refs.map((ref, index) => (
                    <input
                        key={index}
                        className="otpInputStyle"
                        type="text"
                        ref={ref}
                        inputMode="numeric"
                        value={this.state.otp[index].trim()}
                        onChange={(e) => {}}
                        onKeyDown={(e) => {
                            if (e.key !== "Enter") {
                                e.preventDefault();
                                this.handleKeyPress(index, e);
                            }
                        }}
                        onFocus={(e) => {
                            e.preventDefault();
                            this.handleFocus(index);
                        }}
                        onPaste={(e) => {
                            e.preventDefault();
                            this.handlePaste(index, e);
                        }}
                    />
                ))}
            </div>
        );
    }
}

export default CustomOtpInput;
